import { createFileRoute } from "@tanstack/react-router";
import { ASSETS } from "#/lib/assets";
import { PillHero } from "../components/PillHero.js";

export const Route = createFileRoute("/intl-shipping")({
  head: () => ({ meta: [{ title: "International Shipping" }] }),
  component: IntlShippingPage,
});

function IntlShippingPage() {
  return (
    <div data-screen-label="International Shipping Policies" className="pb-24">
      <PillHero
        content={
          <h1 className="m-0 whitespace-pre-line font-bold font-display text-4xl text-lp-green-dk leading-[1.05] lg:text-6xl">
            {"INTERNATIONAL\nSHIPPING POLICIES"}
          </h1>
        }
        asset={
          <img
            src={ASSETS.heroIntlShipping}
            alt=""
            className="h-56 w-auto object-cover md:h-96"
          />
        }
        assetAlign="edge"
        assetClassName="md:-my-14 md:-ml-10"
      />

      <div className="mx-auto mt-12 w-full max-w-4xl px-6 md:px-10">
        <div className="border-lp-green-mid/40 border-b pb-8" />
        <h2 className="m-0 mt-12 mb-12 text-center font-display font-semibold text-2xl text-lp-green-dk">
          For International Buyers
        </h2>
        <ul className="m-0 list-disc space-y-5 pl-8 font-display text-base text-lp-text-dk leading-relaxed">
          <li>Shipping fee is automatically calculated upon checkout.</li>
          <li>
            Shipping cost consists of shipping rate by weight, fuel surcharge,
            12% tax, and other expenses from Philippine Customs.
          </li>
          <li>
            Learning Plus PH is not liable for the country's custom duties and
            taxes.
          </li>
          <li>
            DTP, duties, taxes, clearance, and other expenses from the
            customer's country will be billed separately. Cost is based on the
            declared value of the order.
          </li>
        </ul>
      </div>
    </div>
  );
}
